"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";

export type AudioSettingsStore = {
  /** 0–1 */
  musicVolume: number;
  /** 0–1 */
  sfxVolume: number;
  musicMuted: boolean;
  sfxMuted: boolean;
  setMusicVolume: (v: number) => void;
  setSfxVolume: (v: number) => void;
  setMusicMuted: (v: boolean) => void;
  setSfxMuted: (v: boolean) => void;
  /** Combined user gain for `HTMLAudioElement.volume` (0–1). */
  outputMultiplier: (isMusic: boolean) => number;
};

function clamp01(n: number): number {
  if (!Number.isFinite(n)) return 1;
  return Math.max(0, Math.min(1, n));
}

export const useAudioSettings = create<AudioSettingsStore>()(
  persist(
    (set, get) => ({
      musicVolume: 1,
      sfxVolume: 1,
      musicMuted: false,
      sfxMuted: false,
      setMusicVolume: (v) => set({ musicVolume: clamp01(v) }),
      setSfxVolume: (v) => set({ sfxVolume: clamp01(v) }),
      setMusicMuted: (v) => set({ musicMuted: v }),
      setSfxMuted: (v) => set({ sfxMuted: v }),
      outputMultiplier: (isMusic) => {
        const s = get();
        if (isMusic) return s.musicMuted ? 0 : clamp01(s.musicVolume);
        return s.sfxMuted ? 0 : clamp01(s.sfxVolume);
      },
    }),
    { name: "cwf-audio-settings-v1" },
  ),
);
